import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';
import StatusIcon = RsnDialog.StatusIcon;

export function InvalidPasswordDialog() {
    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader icon={{element: <StatusIcon status={'alert'} />}}>
                Invalid password
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>You entered the wrong password. Check the correctness and try again.</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent={'secondary'}>
                    Continue
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
